export class PlaybackRequestGuard {
  private generation = 0

  begin(): number {
    this.generation += 1
    return this.generation
  }

  cancel(): void {
    this.generation += 1
  }

  isCurrent(request: number): boolean {
    return request === this.generation
  }
}
